module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image15.98fc33f2.jpg";